<!-- El Age Gate se muestra siempre -->
<app-agegate></app-agegate>

<!-- Mostrar Header SOLO si NO estamos en una ruta de admin -->
@if (!isAdminRoute()) {
  <app-header></app-header>
}

<main class="main-workspace">
  <router-outlet></router-outlet>
</main>

<!-- Mostrar Footer y ChatBot SOLO si NO estamos en una ruta de admin -->
@if (!isAdminRoute()) {
  @defer (on viewport) {
    <app-footer></app-footer>
  } @placeholder {
    <div style="min-height: 120px;"></div>
  }

  @defer (on idle) {
    <app-chat-bot></app-chat-bot>
  }
}

